import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

// @Utils
import { axiosEstimates } from '../../utils/api';

// @Interfaces
import { IBudgetById } from '../../models';

export function useBudgetPrint() {
  const [budget, setBudget] = useState<IBudgetById | undefined>();

  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);

  const handleGet = async () => {
    try {
      const response = await axiosEstimates.get<IBudgetById>('budget/' + id);
      setBudget(response.data);
    } catch (error: any) {
      console.error(error);

      // Sin permiso (403 del API) no hay nada que imprimir: se avisa y se vuelve al listado.
      if (error?.response?.status === 403) {
        toast.error(t('general.noPermission', { ns: 'common' }));
        navigate('/budgets');
      }
    }
  };

  useEffect(() => {
    handleGet();
  }, []);

  return { budget };
}
